export default function assertFeature(feature: string): boolean {
  const flag = `REACT_APP_${feature}`;
  return process.env[flag] ? process.env[flag] === "true" : false;
}
